import { useAnalysisTargetDeleteApi } from '@/common/api/modules/mediaAnalysisTarget'
import { analysisTargetEditPath } from '@/common/app/path'
import { MediaAnalysisTarget } from '@/common/model/media/mediaAnalysisTarget'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import TextButton from '@/components/view/atoms/button/TextButton'
import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import ClickableTableRow from '@/components/view/atoms/table/ClickableTableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text from '@/components/view/atoms/text/Text'

interface Props {
  target: MediaAnalysisTarget
  onRefresh: () => void
}

const AnalysisTargetListRow = ({ target, onRefresh }: Props) => {
  const { onClickDelete } = useAnalysisTargetDeleteApi(target, onRefresh)
  const editPath = analysisTargetEditPath(target.site_id, target.id)

  return (
    <ClickableTableRow href={editPath}>
      <TableRowItem width={320}>
        <TextButton link={editPath} bold>
          {target.name}
        </TextButton>
      </TableRowItem>
      <TableRowItem>
        <Text size={14}>{target.site_url}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>{target.competitor_domains.length}件</Text>
      </TableRowItem>
      <TableRowItem width={64}>
        <Button color={ButtonColor.SECONDARY} size='icon' square onClick={onClickDelete}>
          <Icon type={IconType.TRASH} color={IconColor.CRITICAL} />
        </Button>
      </TableRowItem>
    </ClickableTableRow>
  )
}

export default AnalysisTargetListRow
